import n, { useRef as H, useCallback as w, useSyncExternalStore as nn, useId as G, useState as O, useEffect as F, createContext as en, useMemo as tn, Children as an, useContext as on, createElement as cn, useTransition as rn } from "react";
import { c as _, t as h } from "./useKeyDown-88662051.mjs";
import { u as b } from "./app-51178863.mjs";
import { u as sn, B as g, a as z } from "./useClickOutside-55c64a80.mjs";
import { I as S, W as k } from "./Icon-e01b6482.mjs";
import { L as f } from "./Link-460da2fc.mjs";
import { u as T, L as dn, b as ln, a as K } from "./Logo-8772aba7.mjs";
import { I as j } from "./Image-be3826ec.mjs";
import { M as q, u as W } from "./useModal-5a548e10.mjs";
import "./LinkContext-0c83848a.mjs";
import "./ImageContext-57256dc1.mjs";
function gn(e) {
  const a = H(0), t = H("init"), i = w(() => {
    const c = e?.current?.clientHeight ?? 104, r = window.scrollY - a.current;
    if (a.current = window.scrollY, window.scrollY <= c)
      return t.current = "init";
    if (r === 0)
      return t.current;
    const s = r < 0 ? "up" : "down";
    return t.current = s;
  }, [e]);
  return nn(
    _n,
    i,
    () => "init"
  );
}
function _n(e) {
  return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
}
const un = "rich-text", mn = "hero__text", vn = "mobile", pn = "tablet", kn = "desktop", Ln = "button__text-primary", hn = "button__title", En = "button__title__map", wn = "button__heroTitle", Sn = "heading__page", fn = "heading__section", yn = "heading__menu", Mn = "texts__component_title", xn = "navigation__language-picker--dropdown__link", Hn = "texts__component_title--bold", bn = "texts__lead_text", Cn = "page__lead_text", Nn = "texts__lead_text--bold", In = "texts__paragraph_subtitle", Dn = "texts__paragraph_subtitle--bold", Pn = "texts__body_text", An = "texts__body_text--bold", Tn = "texts__link", On = "texts__caption", Bn = "texts__caption--bold", $n = "page__heading", Un = "navigation__language-picker", Fn = "navigation__language-picker__button", Rn = "navigation__language-picker--dropdown", Vn = "navigation__language-picker--dropdown__heading", zn = "navigation__language-picker--dropdown__list", N = {
  richText: un,
  heroText: mn,
  mobile: vn,
  tablet: pn,
  desktop: kn,
  buttonTextPrimary: Ln,
  buttonTitle: hn,
  buttonTitleMap: En,
  buttonHeroTitle: wn,
  headingPage: Sn,
  headingSection: fn,
  headingMenu: yn,
  textsComponentTitle: Mn,
  navigationLanguagePickerDropdownLink: xn,
  textsComponentTitleBold: Hn,
  textsLeadText: bn,
  pageLeadText: Cn,
  textsLeadTextBold: Nn,
  textsParagraphSubtitle: In,
  textsParagraphSubtitleBold: Dn,
  textsBodyText: Pn,
  textsBodyTextBold: An,
  textsLink: Tn,
  textsCaption: On,
  textsCaptionBold: Bn,
  pageHeading: $n,
  navigationLanguagePicker: Un,
  navigationLanguagePickerButton: Fn,
  navigationLanguagePickerDropdown: Rn,
  navigationLanguagePickerDropdownHeading: Vn,
  navigationLanguagePickerDropdownList: zn
};
function Wn({
  currentLanguage: e,
  availableLanguages: a,
  currentUrlPath: t,
  isNavigationHidden: i,
  i18n: o
}) {
  const c = G(), r = `language-picker-${c}`, s = `language-picker-button-${c}`, l = `language-picker-dropdown-${c}`, { selectLanguageLabel: m = "Select language" } = o || {}, {
    isDropdownOpen: v,
    closeDropdown: E,
    toggleDropdownOpen: u,
    buttonRef: d,
    dropdownRef: y
  } = Gn(i);
  return a.length < 2 ? null : /* @__PURE__ */ n.createElement("div", { id: r, className: N.navigationLanguagePicker }, /* @__PURE__ */ n.createElement(
    "button",
    {
      id: s,
      className: _(
        N.navigationLanguagePickerButton,
        v ? h.textsLeadTextBold : h.textsLeadText
      ),
      "aria-expanded": v,
      "aria-controls": l,
      onClick: u,
      type: "button",
      ref: d
    },
    /* @__PURE__ */ n.createElement("span", null, e.toUpperCase()),
    /* @__PURE__ */ n.createElement(S, { icon: k.GLOBE, size: 24 })
  ), /* @__PURE__ */ n.createElement(
    "div",
    {
      id: l,
      className: N.navigationLanguagePickerDropdown,
      "data-open": v,
      role: "listbox",
      "aria-activedescendant": `${l}-${e}`,
      ref: y
    },
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: _(
          h.headingSection,
          N.navigationLanguagePickerDropdownHeading
        )
      },
      m
    ),
    /* @__PURE__ */ n.createElement("ul", { className: N.navigationLanguagePickerDropdownList }, a.map((C) => /* @__PURE__ */ n.createElement(
      Yn,
      {
        key: C.code,
        ...C,
        closeDropdown: E,
        currentLanguage: e,
        currentUrlPath: t,
        dropdownId: l
      }
    )))
  ));
}
function Yn({
  code: e,
  label: a,
  currentLanguage: t,
  currentUrlPath: i,
  closeDropdown: o,
  dropdownId: c
}) {
  const r = `${c}-${e}`, s = e === t;
  return /* @__PURE__ */ n.createElement(
    f,
    {
      key: e,
      id: r,
      className: N.navigationLanguagePickerDropdownLink,
      "aria-selected": s,
      locale: e,
      href: i,
      disableLinkTextStyle: !0,
      role: "listitem",
      onClick: o
    },
    e.toUpperCase(),
    " - ",
    a
  );
}
function Gn(e) {
  const [a, t] = O(!1), i = w(
    () => t((s) => !s),
    []
  ), o = w(() => t(!1), []), c = H(null), r = H(null);
  return F(() => {
    e && o();
  }, [e, o]), sn([c, r], o), {
    isDropdownOpen: a,
    toggleDropdownOpen: i,
    closeDropdown: o,
    buttonRef: c,
    dropdownRef: r
  };
}
const Kn = "navigation__switch_link", jn = "navigation__links_section", qn = "desktop", Jn = "navigation__links_section__link", Qn = "navigation__links_section__link--primary", Xn = "navigation__links_section__link--secondary", Zn = "navigation__modal", A = {
  navigationSwitchLink: Kn,
  navigationLinksSection: jn,
  desktop: qn,
  navigationLinksSectionLink: Jn,
  navigationLinksSectionLinkPrimary: Qn,
  navigationLinksSectionLinkSecondary: Xn,
  navigationModal: Zn
};
function V(e) {
  return /* @__PURE__ */ n.createElement("nav", { key: e.id, className: A.navigationLinksSection }, /* @__PURE__ */ n.createElement(Y, { key: `${e.id}-primary`, ...e, isPrimary: !0 }), J(e).map((a) => /* @__PURE__ */ n.createElement(
    Y,
    {
      key: a.id,
      ...a,
      closeMenu: e.closeMenu
    }
  )));
}
function Y({
  id: e,
  href: a,
  locale: t,
  title: i,
  isPrimary: o,
  closeMenu: c
}) {
  const r = _(
    A.navigationLinksSectionLink,
    o ? A.navigationLinksSectionLinkPrimary : A.navigationLinksSectionLinkSecondary,
    o ? h.textsLeadTextBold : h.textsLeadText
  );
  return /* @__PURE__ */ n.createElement(
    f,
    {
      key: e,
      href: a,
      locale: t,
      itemProp: "url",
      className: r,
      disableLinkTextStyle: !0,
      onClick: c
    },
    /* @__PURE__ */ n.createElement("span", { itemProp: "name" }, i),
    /* @__PURE__ */ n.createElement(S, { icon: k.ARROW_RIGHT, size: 20 })
  );
}
function J(e) {
  return e.subPages?.flatMap((a) => [
    a,
    ...J(a)
  ]) || [];
}
const ne = "navigation__links", ee = "desktop", te = "navigation__links__link", ae = "navigation__links__dropdown", oe = "navigation__links__dropdown--employer", ie = "navigation__links__dropdown__main", ce = "navigation__links__dropdown__featured", re = "navigation__links__dropdown__featured__image", se = "navigation__links__dropdown__featured__link", M = {
  navigationLinks: ne,
  desktop: ee,
  navigationLinksLink: te,
  navigationLinksDropdown: ae,
  navigationLinksDropdownEmployer: oe,
  navigationLinksDropdownMain: ie,
  navigationLinksDropdownFeatured: ce,
  navigationLinksDropdownFeaturedImage: re,
  navigationLinksDropdownFeaturedLink: se
};
function de({
  links: e,
  isNavigationHidden: a,
  i18n: t,
  currentPageId: i
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: M.navigationLinks,
      "data-testid": "navigation-links",
      role: "navigation",
      itemScope: !0,
      itemType: "https://schema.org/SiteNavigationElement"
    },
    e.map((o) => /* @__PURE__ */ n.createElement(
      le,
      {
        key: o.id,
        ...o,
        isNavigationHidden: a,
        i18n: t,
        currentPageId: i
      }
    ))
  );
}
function le({
  id: e,
  href: a,
  locale: t,
  title: i,
  subPages: o,
  featured: c,
  isNavigationHidden: r,
  i18n: s,
  currentPageId: l
}) {
  const { isHovering: m, ref: v } = T(), {
    isHovering: E,
    ref: u,
    setIsHovering: d
  } = T(), y = !r && (m || E), C = w(
    () => d(!1),
    [d]
  );
  return /* @__PURE__ */ n.createElement("li", { role: "none" }, /* @__PURE__ */ n.createElement(
    f,
    {
      ref: v,
      disableLinkTextStyle: !0,
      itemProp: "url",
      href: a,
      locale: t,
      "data-title": i,
      className: _(
        M.navigationLinksLink,
        y || l === e ? h.textsLeadTextBold : h.textsLeadText
      )
    },
    /* @__PURE__ */ n.createElement("span", { itemProp: "name" }, i)
  ), /* @__PURE__ */ n.createElement("div", { ref: u, role: "none" }, o && o.length > 0 && y ? /* @__PURE__ */ n.createElement(
    ge,
    {
      links: o,
      featured: c,
      i18n: s,
      closeMenu: C
    }
  ) : null));
}
function ge({
  links: e,
  featured: a,
  i18n: t,
  closeMenu: i
}) {
  const o = b();
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: _(
        M.navigationLinksDropdown,
        o && M.navigationLinksDropdownEmployer
      )
    },
    /* @__PURE__ */ n.createElement(
      g,
      {
        as: "aside",
        className: M.navigationLinksDropdownMain,
        topPadding: g.Padding.NONE,
        bottomPadding: g.Padding.NONE
      },
      /* @__PURE__ */ n.createElement(g.Content, null, e.map((c) => /* @__PURE__ */ n.createElement(V, { key: c.id, ...c, closeMenu: i })), a ? /* @__PURE__ */ n.createElement(_e, { ...a, i18n: t }) : null)
    )
  );
}
function _e({
  image: e,
  linkUrl: a,
  title: t,
  i18n: i
}) {
  const { featureArticleText: o = "Feature article", readMoreText: c = "Read more" } = i || {};
  return /* @__PURE__ */ n.createElement("div", { className: M.navigationLinksDropdownFeatured }, /* @__PURE__ */ n.createElement(
    j,
    {
      ...e,
      className: M.navigationLinksDropdownFeaturedImage
    }
  ), /* @__PURE__ */ n.createElement("span", null, o, ": ", t), /* @__PURE__ */ n.createElement(
    f,
    {
      href: a,
      className: M.navigationLinksDropdownFeaturedLink
    },
    c
  ));
}
const ue = "navigation__header", me = "navigation__header--modal-open", ve = "desktop", pe = "navigation__header--visible", ke = "navigation__header--show", Le = "animateShow", he = "navigation__header--hide", Ee = "animateHide", we = "navigation__header--employers", Se = "navigation__header__content", fe = "navigation__header__logo", ye = "navigation__header__actions", Me = "navigation__header__search", xe = "navigation__header__menu", He = "navigation__header__search--employers", be = "navigation__header__menu--employers", Ce = "navigation__header__saved_items_link", Ne = "navigation__header__saved_items_link__with-dot", p = {
  navigationHeader: ue,
  navigationHeaderModalOpen: me,
  desktop: ve,
  navigationHeaderVisible: pe,
  navigationHeaderShow: ke,
  animateShow: Le,
  navigationHeaderHide: he,
  animateHide: Ee,
  navigationHeaderEmployers: we,
  navigationHeaderContent: Se,
  navigationHeaderLogo: fe,
  navigationHeaderActions: ye,
  navigationHeaderSearch: Me,
  navigationHeaderMenu: xe,
  navigationHeaderSearchEmployers: He,
  navigationHeaderMenuEmployers: be,
  navigationHeaderSavedItemsLink: Ce,
  navigationHeaderSavedItemsLinkWithDot: Ne
}, Ie = "contact__us", De = "desktop", Pe = "contact__us__link", Ae = "contact__us__dropdown", Te = "contact__us__dropdown--employer", Oe = "contact__us__dropdown__main", Be = "contact__us__dropdown__featured", $e = "contact__us__dropdown__featured__image", Ue = "contact__us__dropdown__featured__link", Fe = "contact__us__dropdown__footer", x = {
  contactUs: Ie,
  desktop: De,
  contactUsLink: Pe,
  contactUsDropdown: Ae,
  contactUsDropdownEmployer: Te,
  contactUsDropdownMain: Oe,
  contactUsDropdownFeatured: Be,
  contactUsDropdownFeaturedImage: $e,
  contactUsDropdownFeaturedLink: Ue,
  contactUsDropdownFooter: Fe
};
function Re({
  links: e,
  isContactUsHidden: a,
  i18n: t,
  currentPageId: i
}) {
  const { isHovering: o, ref: c } = T(), {
    isHovering: r,
    ref: s,
    setIsHovering: l
  } = T(), m = !a && (o || r), v = w(
    () => l(!1),
    [l]
  );
  return /* @__PURE__ */ n.createElement("div", { className: x.contactUs }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: c,
      className: _(
        x.contactUsLink,
        m || i === e[0]?.id ? h.textsLeadTextBold : h.textsLeadText
      )
    },
    /* @__PURE__ */ n.createElement(S, { icon: k.CONTACT, size: 24 })
  ), /* @__PURE__ */ n.createElement("div", { ref: s, role: "none" }, e[0]?.subPages && e[0]?.subPages?.length > 0 && m ? /* @__PURE__ */ n.createElement(
    Ve,
    {
      links: e[0]?.subPages,
      featured: e[0]?.featured,
      i18n: t,
      closeMenu: v
    }
  ) : null));
}
function Ve({
  links: e,
  featured: a,
  i18n: t,
  closeMenu: i
}) {
  const o = b();
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: _(
        x.contactUsDropdown,
        o && x.contactUsDropdownEmployer
      )
    },
    /* @__PURE__ */ n.createElement(
      g,
      {
        as: "aside",
        className: x.contactUsDropdownMain,
        topPadding: g.Padding.NONE,
        bottomPadding: g.Padding.NONE
      },
      /* @__PURE__ */ n.createElement(g.Content, null, e.map((c) => /* @__PURE__ */ n.createElement(V, { key: c?.id, ...c, closeMenu: i })), a ? /* @__PURE__ */ n.createElement(ze, { ...a, i18n: t }) : null)
    )
  );
}
function ze({
  image: e,
  linkUrl: a,
  title: t,
  i18n: i
}) {
  const { featureArticleText: o = "Feature article", readMoreText: c = "Read more" } = i || {};
  return /* @__PURE__ */ n.createElement("div", { className: x.contactUsDropdownFeatured }, /* @__PURE__ */ n.createElement(
    j,
    {
      ...e,
      className: x.contactUsDropdownFeaturedImage
    }
  ), /* @__PURE__ */ n.createElement("span", null, o, ": ", t), /* @__PURE__ */ n.createElement(
    f,
    {
      href: a,
      className: x.contactUsDropdownFeaturedLink
    },
    c
  ));
}
const We = "top-bar", Ye = "top-bar__switchLinks", Ge = "top-bar__link", Ke = "top-bar__link--active", P = {
  topBar: We,
  topBarSwitchLinks: Ye,
  topBarLink: Ge,
  topBarLinkActive: Ke
}, je = (e) => {
  const { switchLinks: a } = e;
  return /* @__PURE__ */ n.createElement("section", { className: P.topBar }, /* @__PURE__ */ n.createElement("nav", { className: P.topBarSwitchLinks }, a.map((t, i) => /* @__PURE__ */ n.createElement(
    f,
    {
      key: t.id,
      href: t.href,
      locale: t.locale,
      className: _(
        P.topBarLink,
        t.isActive && P.topBarLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0
    },
    i === 0 ? /* @__PURE__ */ n.createElement(S, { icon: k.EMPLOYEE }) : /* @__PURE__ */ n.createElement(S, { icon: k.EMPLOYER }),
    /* @__PURE__ */ n.createElement("span", null, t.title)
  ))));
};
function qe(e) {
  const {
    isSearchDisabled: a,
    links: t,
    logoHref: i,
    onLogoClick: o,
    languagePickerOptions: c,
    isSearchOpen: r,
    onSearchClick: s,
    isMenuOpen: l,
    onMenuClick: m,
    i18n: v,
    switchLinks: E,
    savedItems: u,
    currentPageId: d
  } = e, { headerRef: y, headerClassName: C, isHeaderHidden: B } = nt(), Z = b();
  return /* @__PURE__ */ n.createElement(
    g,
    {
      as: "header",
      blockRef: y,
      className: _(
        C,
        (l || r) && p.navigationHeaderModalOpen
      ),
      "data-testid": "navigation",
      topPadding: g.Padding.NONE,
      bottomPadding: g.Padding.NONE
    },
    /* @__PURE__ */ n.createElement(je, { switchLinks: E }),
    /* @__PURE__ */ n.createElement(g.Content, { className: p.navigationHeaderContent }, /* @__PURE__ */ n.createElement(Je, { onClick: o, href: i }), /* @__PURE__ */ n.createElement(
      de,
      {
        links: t?.filter(($) => $?.id !== "ota-yhteytta"),
        isNavigationHidden: B,
        i18n: v,
        currentPageId: d
      }
    ), /* @__PURE__ */ n.createElement("div", { className: p.navigationHeaderActions }, Z && /* @__PURE__ */ n.createElement(
      Re,
      {
        links: t?.filter(($) => $?.id === "ota-yhteytta"),
        isContactUsHidden: B,
        i18n: v,
        currentPageId: d
      }
    ), c ? /* @__PURE__ */ n.createElement(
      Wn,
      {
        ...c,
        isNavigationHidden: B,
        i18n: v
      }
    ) : null, u ? /* @__PURE__ */ n.createElement(Ze, { ...u }) : null, a ? null : /* @__PURE__ */ n.createElement(
      Qe,
      {
        isSearchOpen: r,
        onSearchClick: s
      }
    ), /* @__PURE__ */ n.createElement(Xe, { isMenuOpen: l, onMenuClick: m })))
  );
}
function Je({
  href: e,
  onClick: a
}) {
  const t = b();
  return /* @__PURE__ */ n.createElement(
    f,
    {
      href: e,
      className: p.navigationHeaderLogo,
      disableLinkTextStyle: !0,
      "data-testid": "navigation-logo",
      title: "Work in Finland logo",
      onClick: a
    },
    /* @__PURE__ */ n.createElement(dn, { color: t ? "secondary" : "primary" })
  );
}
function Qe({
  isSearchOpen: e,
  onSearchClick: a
}) {
  const t = b();
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      title: "Search",
      className: _(
        p.navigationHeaderSearch,
        t && p.navigationHeaderSearchEmployers
      ),
      onClick: a
    },
    /* @__PURE__ */ n.createElement(S, { icon: e ? k.CLOSE : k.SEARCH, size: 24 })
  );
}
function Xe({
  isMenuOpen: e,
  onMenuClick: a
}) {
  const t = b();
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      title: "Menu",
      className: _(
        p.navigationHeaderMenu,
        t && p.navigationHeaderMenuEmployers
      ),
      onClick: a
    },
    /* @__PURE__ */ n.createElement(S, { icon: e ? k.CLOSE : k.HAMBURGER, size: 20 })
  );
}
function Ze({
  href: e,
  isEmpty: a,
  title: t = "Saved Items"
}) {
  return /* @__PURE__ */ n.createElement(
    f,
    {
      href: e,
      title: t,
      "data-testid": "navigation-save-button",
      className: _(
        p.navigationHeaderSavedItemsLink,
        !a && p.navigationHeaderSavedItemsLinkWithDot
      )
    },
    /* @__PURE__ */ n.createElement(S, { icon: k.HEART, size: 24 })
  );
}
function nt() {
  const e = H(null), a = gn(e), t = b(), i = a === "init", o = a === "down", c = a === "up", r = _(
    p.navigationHeader,
    h.textsLeadText,
    t && p.navigationHeaderEmployers,
    i && p.navigationHeaderVisible,
    c && p.navigationHeaderShow,
    o && p.navigationHeaderHide
  );
  return { headerRef: e, headerClassName: r, isHeaderHidden: o };
}
const et = "accordion", tt = "accordion__item", at = "accordion__item__heading", ot = "active", it = "accordion__item__content", ct = "accordion__item__content--expanded", I = {
  accordion: et,
  accordionItem: tt,
  accordionItemHeading: at,
  active: ot,
  accordionItemContent: it,
  accordionItemContentExpanded: ct
}, Q = en(void 0);
function rt(e = {}, a) {
  const { collapsible: t = !1, multiple: i = !1, defaultActiveId: o } = e, [c, r] = O(
    () => U(e)
  ), s = tn(() => (an.map(a, (d) => {
    if (d && typeof d == "object" && "type" in d)
      return d.props?.id;
  }) || []).filter(Boolean), [a]), l = w(
    (u) => {
      r((d) => i ? d.includes(u) ? !t && d.length === 1 ? d : d.filter((y) => y !== u) : [...d, u] : t ? d.includes(u) ? [] : [u] : [u]);
    },
    [t, i]
  ), m = w(() => {
    r(U({ defaultActiveId: o, collapsible: t }));
  }, [o, t]), v = w(
    () => r(
      t ? [] : U({ defaultActiveId: o, collapsible: t })
    ),
    [o, t]
  ), E = w(() => {
    i && r(s);
  }, [i, s]);
  return { activeIds: c, toggleId: l, resetIds: m, collapseAll: v, expandAll: E };
}
function U({
  defaultActiveId: e,
  collapsible: a,
  allIds: t = []
} = {}) {
  if (e)
    return [e];
  if (a)
    return [];
  const i = t[0];
  return i ? [i] : [];
}
function X({
  id: e,
  heading: a,
  children: t,
  className: i,
  disabled: o
}) {
  const c = on(Q);
  if (!c)
    throw new Error("Accordion.Item must be used within Accordion");
  const { activeIds: r, toggleId: s, id: l } = c, m = r.includes(e), v = {
    expanded: m,
    toggleItem: () => s(e)
  }, E = l + "-item-" + e, u = l + "-item-" + e + "-label", d = l + "-item-" + e + "-content";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      id: E,
      "aria-expanded": m,
      className: _(I.accordionItem),
      "data-testid": "accordion-item"
    },
    /* @__PURE__ */ n.createElement(
      "button",
      {
        id: u,
        className: _(
          I.accordionItemHeading,
          m && "active",
          o && "disabled"
        ),
        onClick: () => s(e),
        disabled: o,
        "aria-controls": d,
        "aria-expanded": m,
        "data-testid": "accordion-toggler"
      },
      typeof a != "string" ? cn(a, v) : a
    ),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        id: d,
        className: _(
          I.accordionItemContent,
          m && I.accordionItemContentExpanded,
          i
        ),
        role: "region",
        "aria-labelledby": u,
        "data-testid": "accordion-item-content-expanded"
      },
      t
    )
  );
}
function R({
  className: e,
  children: a,
  collapsible: t,
  multiple: i,
  defaultActiveId: o,
  ...c
}) {
  ln(a, X, "Accordion");
  const r = G(), s = rt(
    {
      collapsible: t,
      multiple: i,
      defaultActiveId: o
    },
    a
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: _(I.accordion, e),
      ...c,
      "data-testid": "accordion"
    },
    /* @__PURE__ */ n.createElement(
      Q.Provider,
      {
        value: { ...s, id: c.id || r }
      },
      a
    )
  );
}
R.Item = X;
const st = "navigation__switch_link", dt = "navigation__links_section", lt = "desktop", gt = "navigation__links_section__link", _t = "navigation__links_section__link--primary", ut = "navigation__links_section__link--secondary", mt = "navigation__modal", vt = "navigation__menu", pt = "navigation__menu__switchLinks", kt = "navigation__menu__switchLinks__content", Lt = "navigation__menu__switchLinks__link", ht = "navigation__menu__switchLinks__link--active", Et = "navigation__menu__accordion", wt = "navigation__menu__accordion__heading", St = "navigation__menu__accordion__heading__container", ft = "navigation__menu__accordion__heading__link", yt = "navigation__menu__accordion__heading__icon", Mt = "navigation__menu__accordion__content", xt = "navigation__menu__accordion__content--employers", Ht = "navigation__menu__accordion__content__container", bt = "navigation__menu__footer", L = {
  navigationSwitchLink: st,
  navigationLinksSection: dt,
  desktop: lt,
  navigationLinksSectionLink: gt,
  navigationLinksSectionLinkPrimary: _t,
  navigationLinksSectionLinkSecondary: ut,
  navigationModal: mt,
  navigationMenu: vt,
  navigationMenuSwitchLinks: pt,
  navigationMenuSwitchLinksContent: kt,
  navigationMenuSwitchLinksLink: Lt,
  navigationMenuSwitchLinksLinkActive: ht,
  navigationMenuAccordion: Et,
  navigationMenuAccordionHeading: wt,
  navigationMenuAccordionHeadingContainer: St,
  navigationMenuAccordionHeadingLink: ft,
  navigationMenuAccordionHeadingIcon: yt,
  navigationMenuAccordionContent: Mt,
  navigationMenuAccordionContentEmployers: xt,
  navigationMenuAccordionContentContainer: Ht,
  navigationMenuFooter: bt
};
function Ct(e) {
  const { links: a = [], closeMenu: t, switchLinks: i, currentPageId: o } = e, c = K(), r = b();
  return /* @__PURE__ */ n.createElement(
    q,
    {
      className: L.navigationMenu,
      "data-testid": "menu-mobile",
      modalRef: c,
      closeModal: t
    },
    /* @__PURE__ */ n.createElement(Nt, { switchLinks: i, closeMenu: t }),
    /* @__PURE__ */ n.createElement(
      R,
      {
        className: L.navigationMenuAccordion,
        defaultActiveId: o || a?.[0]?.id,
        collapsible: !0,
        "data-testid": "menu-mobile-accordion"
      },
      a?.filter((s) => s?.id !== "ota-yhteytta")?.map(({ id: s, title: l, href: m, locale: v, subPages: E = [] }) => {
        const u = E.length === 0;
        return /* @__PURE__ */ n.createElement(
          R.Item,
          {
            key: s,
            id: s,
            disabled: u,
            heading: ({ expanded: d }) => /* @__PURE__ */ n.createElement(
              It,
              {
                expanded: d,
                href: m,
                locale: v,
                closeMenu: t,
                hideIcon: u
              },
              l
            )
          },
          u ? null : /* @__PURE__ */ n.createElement(
            g,
            {
              className: _(
                L.navigationMenuAccordionContent,
                r && L.navigationMenuAccordionContentEmployers
              ),
              topPadding: g.Padding.NONE,
              bottomPadding: g.Padding.NONE
            },
            /* @__PURE__ */ n.createElement(
              g.Content,
              {
                className: L.navigationMenuAccordionContentContainer
              },
              E.map((d) => /* @__PURE__ */ n.createElement(
                V,
                {
                  key: d.id,
                  ...d,
                  closeMenu: t
                }
              ))
            )
          )
        );
      })
    )
  );
}
const Nt = ({
  switchLinks: e,
  closeMenu: a
}) => /* @__PURE__ */ n.createElement(
  g,
  {
    topPadding: g.Padding.NONE,
    bottomPadding: g.Padding.NONE,
    className: L.navigationMenuSwitchLinks
  },
  /* @__PURE__ */ n.createElement(g.Content, { flex: !0, className: L.navigationMenuSwitchLinksContent }, e.map((t) => /* @__PURE__ */ n.createElement(
    f,
    {
      key: t.id,
      href: t.href,
      onClick: t.isActive ? void 0 : a,
      className: _(
        L.navigationMenuSwitchLinksLink,
        t.isActive && L.navigationMenuSwitchLinksLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0,
      itemProp: "url"
    },
    /* @__PURE__ */ n.createElement("span", { itemProp: "name" }, t.title)
  )))
);
function It({
  expanded: e,
  children: a,
  href: t,
  locale: i,
  closeMenu: o,
  hideIcon: c
}) {
  return /* @__PURE__ */ n.createElement(g, { className: L.navigationMenuAccordionHeading }, /* @__PURE__ */ n.createElement(
    g.Content,
    {
      flex: !0,
      className: L.navigationMenuAccordionHeadingContainer
    },
    /* @__PURE__ */ n.createElement(
      f,
      {
        href: t,
        onClick: o,
        locale: i,
        title: a,
        disableLinkTextStyle: !0,
        className: _(
          L.navigationMenuAccordionHeadingLink,
          e ? h.headingSection : h.headingMenu
        ),
        itemProp: "url"
      },
      /* @__PURE__ */ n.createElement("span", { itemProp: "name" }, a)
    ),
    c ? null : /* @__PURE__ */ n.createElement(
      S,
      {
        className: L.navigationMenuAccordionHeadingIcon,
        icon: e ? k.CHEVRON_UP : k.CHEVRON_DOWN,
        size: 16
      }
    )
  ));
}
const Dt = "navigation__switch_link", Pt = "navigation__links_section", At = "desktop", Tt = "navigation__links_section__link", Ot = "navigation__links_section__link--primary", Bt = "navigation__links_section__link--secondary", $t = "navigation__modal", Ut = "navigation__search", Ft = "navigation__search__content", Rt = "navigation__search__input", Vt = "navigation__search__input__button", zt = "navigation__search__input__field", D = {
  navigationSwitchLink: Dt,
  navigationLinksSection: Pt,
  desktop: At,
  navigationLinksSectionLink: Tt,
  navigationLinksSectionLinkPrimary: Ot,
  navigationLinksSectionLinkSecondary: Bt,
  navigationModal: $t,
  navigationSearch: Ut,
  navigationSearchContent: Ft,
  navigationSearchInput: Rt,
  navigationSearchInputButton: Vt,
  navigationSearchInputField: zt
};
function Wt({
  defaultKeyword: e = "",
  closeSearch: a,
  renderContent: t
}) {
  const i = K(), [o, c] = O(e);
  return /* @__PURE__ */ n.createElement(
    q,
    {
      className: D.navigationSearch,
      "data-testid": "search",
      modalRef: i,
      closeModal: a
    },
    /* @__PURE__ */ n.createElement(g, { topPadding: z.NONE, bottomPadding: z.NONE }, /* @__PURE__ */ n.createElement(g.Content, { className: D.navigationSearchContent }, /* @__PURE__ */ n.createElement(Yt, { onChange: c, defaultValue: e }))),
    t({ keyword: o, closeModal: a })
  );
}
function Yt({
  onChange: e,
  defaultValue: a,
  placeholder: t = "Search for keywords..."
}) {
  const [i, o] = O(a), [, c] = rn(), r = H(null), s = w(() => {
    o(""), r.current?.focus();
  }, []);
  return F(() => {
    c(() => e(i));
  }, [e, i]), F(() => {
    r.current?.focus();
  }, []), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: _(D.navigationSearchInput),
      "data-testid": "search-input"
    },
    /* @__PURE__ */ n.createElement(
      "button",
      {
        title: "Search",
        onClick: s,
        "data-testid": "search-input-button",
        className: D.navigationSearchInputButton
      },
      /* @__PURE__ */ n.createElement(
        S,
        {
          icon: i.length > 0 ? k.CLOSE : k.SEARCH,
          size: 24
        }
      )
    ),
    /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "text",
        ref: r,
        value: i,
        onChange: (l) => o(l.target.value),
        placeholder: t,
        "data-testid": "search-input-field",
        className: _(
          D.navigationSearchInputField,
          h.textsComponentTitle
        )
      }
    )
  );
}
function oa(e) {
  const {
    isMenuOpen: a,
    isSearchOpen: t,
    toggleMenuOpen: i,
    toggleSearchOpen: o,
    closeMenu: c,
    closeSearch: r,
    closeAllModals: s
  } = Gt();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    qe,
    {
      ...e,
      isMenuOpen: a,
      onMenuClick: i,
      isSearchOpen: t,
      onSearchClick: o,
      onLogoClick: s
    }
  ), a ? /* @__PURE__ */ n.createElement(
    Ct,
    {
      links: e.links,
      switchLinks: e.switchLinks,
      closeMenu: c,
      currentPageId: e.currentPageId
    }
  ) : null, t ? /* @__PURE__ */ n.createElement(
    Wt,
    {
      closeSearch: r,
      renderContent: e.searchContent,
      defaultKeyword: e.defaultSearchKeyword
    }
  ) : null);
}
function Gt() {
  const e = H(void 0), a = H(void 0), {
    isModalOpen: t,
    toggleModalOpen: i,
    closeModal: o
  } = W({ onOpen: e.current }), {
    isModalOpen: c,
    toggleModalOpen: r,
    closeModal: s
  } = W({ onOpen: a.current });
  a.current = o, e.current = s;
  const l = w(() => {
    o(), s();
  }, [o, s]);
  return {
    isMenuOpen: t,
    isSearchOpen: c,
    toggleMenuOpen: i,
    toggleSearchOpen: r,
    closeMenu: o,
    closeSearch: s,
    closeAllModals: l
  };
}
export {
  oa as default
};
//# sourceMappingURL=Navigation.js.map
